import type * as ngCore from '@angular/core'

import * as routeBound from '../route-bound'

import * as attributes from './attributes'
import * as common from './common'
import * as records from './records'
import * as uploads from './uploads'
import * as entities from './entities'
import * as enumEntries from './enum-entries'
import * as enums from './enums'
import * as dimensions from './dimensions'
import * as schema from './schema'
import * as snapshots from './snapshots'

export {
  attributes,
  common,
  records,
  uploads,
  entities,
  enumEntries,
  enums,
  dimensions,
  schema,
  snapshots,
}

export function provideEntityCollections(): ngCore.Provider[] {
  return [
    attributes.Api,
    routeBound.Registry.provideDestroyable(attributes.Collection),
    dimensions.Api,
    routeBound.Registry.provideDestroyable(dimensions.Collection),
    entities.Api,
    routeBound.Registry.provideDestroyable(entities.Collection),
    enumEntries.Api,
    routeBound.Registry.provideDestroyable(enumEntries.Collection),
    enums.Api,
    routeBound.Registry.provideDestroyable(enums.Collection),
    records.Api,
    routeBound.Registry.provideDestroyable(records.Collection),
    snapshots.Api,
    routeBound.Registry.provideDestroyable(snapshots.Collection),
    uploads.Api,
  ]
}
